import { render, staticRenderFns } from "./DataCenterTable.vue?vue&type=template&id=35ff576f&scoped=true"
import script from "./DataCenterTable.vue?vue&type=script&lang=js"
export * from "./DataCenterTable.vue?vue&type=script&lang=js"
import style0 from "./DataCenterTable.vue?vue&type=style&index=0&id=35ff576f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff576f",
  null
  
)

export default component.exports